import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";

// const debug = "ExpensesModule"
const debug = false

export class TwoFAModule extends ModuleProto {

    constructor(moduleConfig:any) {
        super(ModuleType.TWO_FA, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=",moduleConfig)

        this.name                     = "2 Factor Authentication"
        this.description              = "When enabled, this module adds an extra level of security with 2-Factor Authentication, providing an additional layer of protection."
        this.typeLabel                = "Access & Permissions"
        this.svgIcon                  = "isvg-2fa"
        this.settingsMenuTopCategory  = SettingsMenuTopCategory.ORGANIZATION
        this.canDisable               = true
        this._isEnabled               = _.get(moduleConfig,'isEnabled', false)
        this.settingsUrl              = "settings/2fa"

        this.feature                    = Feature.TWO_FA
        this.validateFeature()


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    // disable():void {
    //     console.warn("Labor cost module always enabled as it is old one")
    // }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        const result = super.toJson();
        // const result = {}

        debug && console.log(debug, "    newConfig=", result)

        return result
    }

    goToSettings() {
        gd.navigation.goTo('settings/2fa')
    }


}